import { GlobalRole, ServiceRole, WorkspaceRole } from '../types';

type RoleOption = {
  value: ServiceRole | WorkspaceRole;
  label: string;
  description: string;
};

const SERVICE_NAMES: Record<string, string> = {
  short: '쇼티',
  checkin: '체크인',
};

export const getServiceDisplayName = (serviceCode?: string | null) => {
  if (!serviceCode) return '서비스';
  return SERVICE_NAMES[serviceCode] || serviceCode;
};

export const getGlobalRoleLabel = (role?: GlobalRole | null) => {
  switch (role) {
    case 'ROOT_ADMIN':
      return '시스템 최고관리자';
    case 'NONE':
      return '일반 사용자';
    default:
      return '알 수 없음';
  }
};

export const getServiceRoleLabel = (serviceCode: string | undefined, role?: ServiceRole | null) => {
  const serviceName = getServiceDisplayName(serviceCode);
  switch (role) {
    case 'SERVICE_OWNER':
      return serviceCode === 'short' ? `${serviceName} 관리자` : `${serviceName} 최고관리자`;
    case 'SERVICE_ADMIN':
      return serviceCode === 'short' ? `${serviceName} 운영자` : `${serviceName} 서비스 관리자`;
    case 'SERVICE_VIEWER':
      return '유저';
    default:
      return '없음';
  }
};

export const getWorkspaceRoleLabel = (role?: WorkspaceRole | string | null) => {
  switch (role) {
    case 'WORKSPACE_ADMIN':
      return '워크스페이스 관리자';
    case 'WORKSPACE_VIEWER':
      return '워크스페이스 유저';
    default:
      return '없음';
  }
};

export const getServiceMemberRoleOptions = (serviceCode: string): RoleOption[] => {
  if (serviceCode === 'short') {
    return [
      {
        value: 'SERVICE_VIEWER',
        label: '유저',
        description: '쇼티를 사용하는 일반 사용자입니다.',
      },
    ];
  }

  if (serviceCode === 'checkin') {
    return [
      {
        value: 'SERVICE_VIEWER',
        label: '유저',
        description: '체크인 서비스를 사용하는 일반 사용자입니다.',
      },
      {
        value: 'SERVICE_ADMIN',
        label: '서비스 관리자',
        description: '체크인 서비스의 운영을 보조하는 관리자입니다.',
      },
    ];
  }

  return [
    {
      value: 'SERVICE_VIEWER',
      label: '유저',
      description: '일반 사용자입니다.',
    },
    {
      value: 'SERVICE_ADMIN',
      label: '서비스 관리자',
      description: '서비스 운영을 관리합니다.',
    },
    {
      value: 'SERVICE_OWNER',
      label: '최고관리자',
      description: '서비스의 최종 관리 권한입니다.',
    },
  ];
};

export const getWorkspaceMemberRoleOptions = (): RoleOption[] => [
  {
    value: 'WORKSPACE_VIEWER',
    label: '워크스페이스 유저',
    description: '워크스페이스의 일반 사용자입니다.',
  },
  {
    value: 'WORKSPACE_ADMIN',
    label: '워크스페이스 관리자',
    description: '워크스페이스를 전담 관리합니다.',
  },
];

